// src/utils/api.js

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const API = (path) => `${API_URL}${path}`;
